import { forwardRef, useEffect, useRef } from 'react'
import SimpleBar from 'simplebar-react'
import styled from 'styled-components'

const SimpleBarStyled = styled(SimpleBar)`
  width: ${(props) => props.width};
`

const Scrollbar = forwardRef(
  ({ children, maxHeight, onVerticalScrollChange, ...props }, ref) => {
    const simpleBarRef = useRef(null)

    const setRefs = (instance) => {
      simpleBarRef.current = instance

      if (typeof ref === 'function') {
        ref(instance)
      } else if (ref) {
        ref.current = instance
      }
    }

    useEffect(() => {
      const scrollElement = simpleBarRef.current?.getScrollElement()

      if (!scrollElement) {
        return
      }

      const hasVerticalScroll =
        scrollElement.scrollHeight > scrollElement.clientHeight

      onVerticalScrollChange?.(hasVerticalScroll)
    }, [children, maxHeight, onVerticalScrollChange])

    return (
      <SimpleBarStyled ref={setRefs} {...props} style={{ maxHeight }}>
        {children}
      </SimpleBarStyled>
    )
  }
)

Scrollbar.displayName = 'Scrollbar'

export default Scrollbar
